import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import type {GitHubHostedRunnersResponse, SelfHostedRunnersData, SelfHostedRunnersResponse} from './types'

async function fetchRunnersJSON<T>(endpoint: string, signal?: AbortSignal): Promise<T> {
  const response = await verifiedFetchJSON(endpoint, {signal})
  if (!response.ok) throw new Error(`Unable to load runners from ${endpoint}: ${response.status}`)
  return response.json()
}

export function fetchGitHubHostedRunners(fetchRunnersBasePath: string, signal?: AbortSignal) {
  return fetchRunnersJSON<GitHubHostedRunnersResponse>(`${fetchRunnersBasePath}/github_hosted_runners`, signal)
}

/** Requests all self-hosted lists in parallel; the tab renders only once every list has loaded. */
export async function fetchSelfHostedRunners(
  fetchRunnersBasePath: string,
  signal?: AbortSignal,
): Promise<SelfHostedRunnersData> {
  const [repoSelfHosted, shared, scaleSets] = await Promise.all([
    fetchRunnersJSON<SelfHostedRunnersResponse>(`${fetchRunnersBasePath}/repository_self_hosted`, signal),
    fetchRunnersJSON<SelfHostedRunnersResponse>(`${fetchRunnersBasePath}/shared_runners`, signal),
    fetchRunnersJSON<SelfHostedRunnersResponse>(`${fetchRunnersBasePath}/repository_scale_sets`, signal),
  ])
  return {repoSelfHosted, shared, scaleSets}
}
